<div class="cell-div">
  <div (click)="onLockIconClick()">
    @if (params?.data?._tags?.includes('disabled') && currentPage !== 'ngp-report') {
      <div>
        <app-icon-lock-closed-outline></app-icon-lock-closed-outline>
      </div>
    }
    @if (!params?.data?._tags?.includes('disabled') && currentPage !== 'ngp-report') {
      <div>
        <app-icon-lock-open-outline></app-icon-lock-open-outline>
      </div>
    }
  </div>
  <div>
    {{ params.value }}
  </div>
</div>

